var map = {
	"./WhatsApp Image 2026-01-06 at 4.23.52 PM.jpeg": 1060,
	"./WhatsApp Image 2026-01-06 at 4.23.53 PM.jpeg": 6577,
	"./WhatsApp Image 2026-01-06 at 4.23.54 PM (1).jpeg": 8324,
	"./WhatsApp Image 2026-01-06 at 4.23.54 PM.jpeg": 6922,
	"./WhatsApp Image 2026-01-06 at 4.23.55 PM (1).jpeg": 8837,
	"./WhatsApp Image 2026-01-06 at 4.23.55 PM.jpeg": 1311,
	"./WhatsApp Image 2026-01-06 at 4.23.56 PM.jpeg": 4696,
	"./WhatsApp Image 2026-01-06 at 4.23.57 PM.jpeg": 6517,
	"./WhatsApp Image 2026-01-06 at 4.23.58 PM (1).jpeg": 3832,
	"./WhatsApp Image 2026-01-06 at 4.23.58 PM.jpeg": 5166,
	"./WhatsApp Image 2026-01-06 at 4.23.59 PM (1).jpeg": 1465,
	"./WhatsApp Image 2026-01-06 at 4.23.59 PM.jpeg": 4771,
	"./WhatsApp Image 2026-01-06 at 4.24.00 PM.jpeg": 6267,
	"./WhatsApp Image 2026-01-06 at 4.24.01 PM.jpeg": 7733,
	"./WhatsApp Image 2026-01-06 at 4.24.02 PM (1).jpeg": 1332,
	"./WhatsApp Image 2026-01-06 at 4.24.02 PM (2).jpeg": 7107,
	"./WhatsApp Image 2026-01-06 at 4.24.02 PM.jpeg": 5258,
	"./WhatsApp Image 2026-01-06 at 4.24.03 PM (1).jpeg": 8869,
	"./WhatsApp Image 2026-01-06 at 4.24.03 PM (2).jpeg": 7754,
	"./WhatsApp Image 2026-01-06 at 4.24.03 PM.jpeg": 9999,
	"./WhatsApp Image 2026-01-06 at 4.24.04 PM (1).jpeg": 6542,
	"./WhatsApp Image 2026-01-06 at 4.24.04 PM (2).jpeg": 1849,
	"./WhatsApp Image 2026-01-06 at 4.24.04 PM.jpeg": 9748,
	"./WhatsApp Image 2026-01-06 at 4.24.05 PM.jpeg": 5265
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7935;